import React from 'react';
import { observer } from 'mobx-react';

export const HighlightedSelection = observer(
  ({ optionText, selection, inserveHighlighting }) => {
    const selectionIndex = optionText
      .toLowerCase()
      .indexOf(selection.toLowerCase());
    if (selectionIndex === -1) {
      return <span>{optionText}</span>;
    }
    const before = optionText.slice(0, selectionIndex);
    const match = optionText.slice(
      selectionIndex,
      selectionIndex + selection.length,
    );
    const after = optionText.slice(selectionIndex + selection.length);
    if (inserveHighlighting) {
      return (
        <span>
          {before}
          <strong>{match}</strong>
          {after}
        </span>
      );
    }
    return (
      <span>
        <strong>{before}</strong>
        {match}
        <strong>{after}</strong>
      </span>
    );
  },
);
